import * as ambassadorWixBenefitProgramsV1PoolDefinition from './benefit-programs-v1-pool-definition-pool-definitions.http.js';
import * as ambassadorWixBenefitProgramsV1PoolDefinitionTypes from './benefit-programs-v1-pool-definition-pool-definitions.types.js';
import * as ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes from './benefit-programs-v1-pool-definition-pool-definitions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createPoolDefinition(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.CreatePoolDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.CreatePoolDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.CreatePoolDefinitionResponse,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.CreatePoolDefinitionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1PoolDefinition.createPoolDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pool-definitions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreatePoolDefinitions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.BulkCreatePoolDefinitionsRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.BulkCreatePoolDefinitionsRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.BulkCreatePoolDefinitionsResponse,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.BulkCreatePoolDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1PoolDefinition.bulkCreatePoolDefinitions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/pool-definitions/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updatePoolDefinition(): __PublicMethodMetaInfo<
  'PATCH',
  { poolDefinitionId: string },
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.UpdatePoolDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.UpdatePoolDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.UpdatePoolDefinitionResponse,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.UpdatePoolDefinitionResponse
> {
  const payload = { poolDefinition: { id: ':poolDefinitionId' } } as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1PoolDefinition.updatePoolDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/pool-definitions/{poolDefinition.id}',
    pathParams: { poolDefinitionId: 'poolDefinitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdatePoolDefinitions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.BulkUpdatePoolDefinitionsRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.BulkUpdatePoolDefinitionsRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.BulkUpdatePoolDefinitionsResponse,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.BulkUpdatePoolDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1PoolDefinition.bulkUpdatePoolDefinitions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/pool-definitions/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deletePoolDefinition(): __PublicMethodMetaInfo<
  'DELETE',
  { poolDefinitionId: string },
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.DeletePoolDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.DeletePoolDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.DeletePoolDefinitionResponse,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.DeletePoolDefinitionResponse
> {
  const payload = { poolDefinitionId: ':poolDefinitionId' } as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1PoolDefinition.deletePoolDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/pool-definitions/{poolDefinitionId}',
    pathParams: { poolDefinitionId: 'poolDefinitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeletePoolDefinitions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.BulkDeletePoolDefinitionsRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.BulkDeletePoolDefinitionsRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.BulkDeletePoolDefinitionsResponse,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.BulkDeletePoolDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1PoolDefinition.bulkDeletePoolDefinitions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/pool-definitions/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPoolDefinition(): __PublicMethodMetaInfo<
  'GET',
  { poolDefinitionId: string },
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.GetPoolDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.GetPoolDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.GetPoolDefinitionResponse,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.GetPoolDefinitionResponse
> {
  const payload = { poolDefinitionId: ':poolDefinitionId' } as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1PoolDefinition.getPoolDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/pool-definitions/{poolDefinitionId}',
    pathParams: { poolDefinitionId: 'poolDefinitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryPoolDefinitions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.QueryPoolDefinitionsRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.QueryPoolDefinitionsRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.QueryPoolDefinitionsResponse,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.QueryPoolDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1PoolDefinition.queryPoolDefinitions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pool-definitions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addPoolDefinitionToProgramDefinition(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.AddPoolDefinitionToProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.AddPoolDefinitionToProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.AddPoolDefinitionToProgramDefinitionResponse,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.AddPoolDefinitionToProgramDefinitionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1PoolDefinition.addPoolDefinitionToProgramDefinition(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pool-definitions/program-definition/assign',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removePoolDefinitionFromProgramDefinition(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.RemovePoolDefinitionFromProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.RemovePoolDefinitionFromProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.RemovePoolDefinitionFromProgramDefinitionResponse,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.RemovePoolDefinitionFromProgramDefinitionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1PoolDefinition.removePoolDefinitionFromProgramDefinition(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pool-definitions/program-definition/remove',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function findPoolDefinitionsByProgramDefinition(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.FindPoolDefinitionsByProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.FindPoolDefinitionsByProgramDefinitionRequest,
  ambassadorWixBenefitProgramsV1PoolDefinitionUniversalTypes.FindPoolDefinitionsByProgramDefinitionResponse,
  ambassadorWixBenefitProgramsV1PoolDefinitionTypes.FindPoolDefinitionsByProgramDefinitionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBenefitProgramsV1PoolDefinition.findPoolDefinitionsByProgramDefinition(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pool-definitions/find-pool-definitions-by-program-definition',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  PoolDefinition as PoolDefinitionOriginal,
  Details as DetailsOriginal,
  Benefit as BenefitOriginal,
  PolicyExpression as PolicyExpressionOriginal,
  PolicyExpressionExpressionOneOf as PolicyExpressionExpressionOneOfOriginal,
  PolicyExpressionType as PolicyExpressionTypeOriginal,
  PolicyExpressionTypeWithLiterals as PolicyExpressionTypeWithLiteralsOriginal,
  PolicyExpressionNot as PolicyExpressionNotOriginal,
  PolicyExpressionAnd as PolicyExpressionAndOriginal,
  PolicyExpressionOr as PolicyExpressionOrOriginal,
  Policy as PolicyOriginal,
  PolicyPolicyOneOf as PolicyPolicyOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  FixedIntervalPolicy as FixedIntervalPolicyOriginal,
  WeekDay as WeekDayOriginal,
  WeekDayWithLiterals as WeekDayWithLiteralsOriginal,
  RateLimitedPolicy as RateLimitedPolicyOriginal,
  TimePeriod as TimePeriodOriginal,
  TimePeriodWithLiterals as TimePeriodWithLiteralsOriginal,
  CustomPolicy as CustomPolicyOriginal,
  CreditConfiguration as CreditConfigurationOriginal,
  RolloverConfiguration as RolloverConfigurationOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ProgramDefinitionInfo as ProgramDefinitionInfoOriginal,
  PoolDefinitionAddedToProgramDefinition as PoolDefinitionAddedToProgramDefinitionOriginal,
  Cascade as CascadeOriginal,
  CascadeWithLiterals as CascadeWithLiteralsOriginal,
  PoolDefinitionRemovedFromProgramDefinition as PoolDefinitionRemovedFromProgramDefinitionOriginal,
  PoolDefinitionUpdatedProxySupport as PoolDefinitionUpdatedProxySupportOriginal,
  PoolDefinitionDeletedProxySupport as PoolDefinitionDeletedProxySupportOriginal,
  PoolDefinitionTranslated as PoolDefinitionTranslatedOriginal,
  PoolDefinitionTranslationDeleted as PoolDefinitionTranslationDeletedOriginal,
  CreatePoolDefinitionRequest as CreatePoolDefinitionRequestOriginal,
  CreatePoolDefinitionResponse as CreatePoolDefinitionResponseOriginal,
  BulkCreatePoolDefinitionsRequest as BulkCreatePoolDefinitionsRequestOriginal,
  BulkCreatePoolDefinitionsResponse as BulkCreatePoolDefinitionsResponseOriginal,
  BulkPoolDefinitionResult as BulkPoolDefinitionResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  UpdatePoolDefinitionRequest as UpdatePoolDefinitionRequestOriginal,
  UpdatePoolDefinitionResponse as UpdatePoolDefinitionResponseOriginal,
  BulkUpdatePoolDefinitionsRequest as BulkUpdatePoolDefinitionsRequestOriginal,
  MaskedPoolDefinition as MaskedPoolDefinitionOriginal,
  BulkUpdatePoolDefinitionsResponse as BulkUpdatePoolDefinitionsResponseOriginal,
  DeletePoolDefinitionRequest as DeletePoolDefinitionRequestOriginal,
  DeletePoolDefinitionResponse as DeletePoolDefinitionResponseOriginal,
  BulkDeletePoolDefinitionsRequest as BulkDeletePoolDefinitionsRequestOriginal,
  BulkDeletePoolDefinitionsResponse as BulkDeletePoolDefinitionsResponseOriginal,
  GetPoolDefinitionRequest as GetPoolDefinitionRequestOriginal,
  GetPoolDefinitionResponse as GetPoolDefinitionResponseOriginal,
  QueryPoolDefinitionsRequest as QueryPoolDefinitionsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryPoolDefinitionsResponse as QueryPoolDefinitionsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  AddPoolDefinitionToProgramDefinitionRequest as AddPoolDefinitionToProgramDefinitionRequestOriginal,
  AddPoolDefinitionToProgramDefinitionResponse as AddPoolDefinitionToProgramDefinitionResponseOriginal,
  RemovePoolDefinitionFromProgramDefinitionRequest as RemovePoolDefinitionFromProgramDefinitionRequestOriginal,
  RemovePoolDefinitionFromProgramDefinitionResponse as RemovePoolDefinitionFromProgramDefinitionResponseOriginal,
  FindPoolDefinitionsByProgramDefinitionRequest as FindPoolDefinitionsByProgramDefinitionRequestOriginal,
  FindPoolDefinitionsByProgramDefinitionResponse as FindPoolDefinitionsByProgramDefinitionResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  UpdatePoolDefinitionValidationErrors as UpdatePoolDefinitionValidationErrorsOriginal,
  BulkUpdatePoolDefinitionsValidationErrors as BulkUpdatePoolDefinitionsValidationErrorsOriginal,
  AddPoolDefinitionToProgramDefinitionValidationErrors as AddPoolDefinitionToProgramDefinitionValidationErrorsOriginal,
  RemovePoolDefinitionFromProgramDefinitionValidationErrors as RemovePoolDefinitionFromProgramDefinitionValidationErrorsOriginal,
} from './benefit-programs-v1-pool-definition-pool-definitions.types.js';
